import { render, staticRenderFns } from "./chemicalUseChild.vue?vue&type=template&id=50bd810d&scoped=true"
import script from "./chemicalUseChild.vue?vue&type=script&lang=js"
export * from "./chemicalUseChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bd810d",
  null
  
)

export default component.exports